import React from 'react';
import PropTypes from 'prop-types';

const LoginButton = ({ submitted, buttonText }) => (
  <div className="input-group-button">
    <button type="submit" className="btn btn--primary" disabled={submitted}>
      {buttonText}
    </button>
  </div>
);

LoginButton.propTypes = {
  submitted: PropTypes.bool.isRequired,
};

export default LoginButton;
